import {
  getAlertForwardRule,
  getAlertForwardMeta,
  setAlertForwardRule,
  deleteAlertForwardRule,
  setAlertForwardRuleToggle,
} from '@api/aiAlertForward';
import { AlertForwardRule, AlertForwardMeta } from './types';
import { useMutation, useQueryClient, useQuery } from '@tanstack/react-query';

const ruleSummaryKey = ['ruleSummary'];
const ruleMetaKey = ['ruleMeta'];

export const useRuleSummary = () => {
  const response = useQuery<AlertForwardRule[]>(
    [ruleSummaryKey],
    () => {
      return getAlertForwardRule<AlertForwardRule[]>();
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 5 * 1000,
    },
  );
  return response;
};

export const useRuleMeta = () => {
  const response = useQuery<AlertForwardMeta>(
    [ruleMetaKey],
    () => {
      return getAlertForwardMeta<AlertForwardMeta>();
    },
    {
      retry: 3,
      refetchOnWindowFocus: false,
      staleTime: 5 * 1000,
    },
  );
  return response;
};

export const useEditRule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (rule: AlertForwardRule) => setAlertForwardRule(rule),
    onSuccess: () => {
      queryClient.invalidateQueries(['alertForwardRules']);
    },
  });
};

export const useCreateRule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (rule: AlertForwardRule) => setAlertForwardRule(rule),
    onSuccess: () => {
      queryClient.invalidateQueries(['alertForwardRules']);
    },
  });
};

export const useToggleRule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (rule: AlertForwardRule) => setAlertForwardRuleToggle(rule),
    onSuccess: () => {
      queryClient.invalidateQueries([ruleSummaryKey]);
    },
  });
};

export const useDeleteRule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (ruleId: number) => deleteAlertForwardRule(ruleId),
    onSuccess: () => {
      queryClient.invalidateQueries([ruleSummaryKey]);
    },
  });
};
